import api from "./api";
import { getApiBaseUrl } from "./apiBase";

const BASE_PUB = getApiBaseUrl();
const svc = {
  listar:           (p={}) => { const qs=new URLSearchParams(Object.entries(p).filter(([,v])=>v!==""&&v!==undefined)); return api("GET",`/assembleias?${qs}`); },
  buscarPorId:      (id)   => api("GET",`/assembleias/${id}`),
  criar:            (data) => api("POST","/assembleias",data),
  atualizar:        (id,data) => api("PUT",`/assembleias/${id}`,data),
  deletar:          (id)   => api("DELETE",`/assembleias/${id}`),
  salvarPautas:     (id,data) => api("PUT",`/assembleias/${id}/pautas`,data),
  convocar:         (id)   => api("POST",`/assembleias/${id}/convocar`,{}),
  reenviarLink:     (id,idUnidade=null) => api("POST",`/assembleias/${id}/reenviar-link`,{idUnidade}),
  mudarStatus:      (id,status) => api("PATCH",`/assembleias/${id}/status`,{status}),
  registrarPresenca:(id,data) => api("POST",`/assembleias/${id}/presenca`,data),
  removerPresenca:  (id,idUnidade) => api("DELETE",`/assembleias/${id}/presenca/${idUnidade}`),
  votar:            (id,data) => api("POST",`/assembleias/${id}/votar`,data),
  resultados:       (id)   => api("GET",`/assembleias/${id}/resultados`),
  gerarAta:         (id)   => api("POST",`/assembleias/${id}/ata`,{}),
  // Anexos
  listarAnexos:     (id)   => api("GET",  `/assembleias/${id}/anexos`),
  uploadAnexo:      (id,d) => api("POST", `/assembleias/${id}/anexos`, d),
  deletarAnexo:     (aid)  => api("DELETE",`/assembleias/anexos/${aid}`),
  // Public (no auth needed)
  buscarPorToken: async (token) => {
    const res = await fetch(`${BASE_PUB}/assembleias/votar/${token}`);
    return res.json();
  },
  votarOnline: async (data) => {
    const res = await fetch(`${BASE_PUB}/assembleias/votar`, {
      method:"POST", headers:{"Content-Type":"application/json"},
      body:JSON.stringify(data),
    });
    return res.json();
  },
};
export default svc;
